<template>
    <div>
        <div v-if="isLoading" class="loader-overlay">
          <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        <div class="container-fluid">
            <div class="llp-container-section heightcontainer">
                <top-header id="height2"></top-header>
                <main-menu id="height3"></main-menu>
                <div class="menu-margin-top">
                    <div class="row px-3 ml-0 ">
                        <div class="col-lg-7 col-sm-12 mt-3">
                            <h3 class="mb-0">Credit Smart</h3>
                            <!-- <small class="data-availability-text">Data availability: {{dataDateRange}}</small> -->
                        </div>
                        <div class="col-lg-3 row ">
                        <div class="col-lg-12 col-sm-12 activitySearch mt-3">
                            <div class="search-input-wrapper">
                                <input 
                                    class="form-control search-input" 
                                    type="text" 
                                    placeholder="Search..." 
                                    v-model="creditSmartListSearch"
                                    @keyup.enter="searchCreditSmart()"
                                >
                                <button 
                                    v-if="creditSmartListSearch" 
                                    type="button" 
                                    class="clear-search-btn" 
                                    @click="clearCreditSmartSearch"
                                    aria-label="Clear search"
                                >
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="currentColor"/>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-2 col-sm-12 activitySearch mt-3 tableFilterAction align-items-baseline">
                            <b-dropdown 
                                ref="filterDropdown"
                                id="filter-dropdown" 
                                :text="'Filter'" 
                                variant="outline-secondary"
                                class="filter-btn-dropdown"
                                right
                                no-caret
                            >
                                <div class="comm-dropdown filterMenuOuter">
                                    <div class="form-wrap">
                                        <div class="d-flex filter-header mb-20">
                                            <h3 class="flex-grow-1">Filter by</h3>
                                            <button 
                                                type="button"
                                                class="btn-link p-0 close-btn" 
                                                @click.stop="closeFilterMenu"
                                                aria-label="Close"
                                            >
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="currentColor"/>
                                                </svg>
                                            </button>
                                        </div>

                                        <div class="form-row">
                                            <div class="inputBox">
                                                <label class="form-label">Date</label>
                                                <div class="dateRangeBox d-flex gap-4">
                                                    <div class="date-input-wrapper" style="flex: 1;">
                                                        <input 
                                                            type="date" 
                                                            class="form-control" 
                                                            v-model="filterStartDate"
                                                            placeholder="Start Date"
                                                            :max="filterEndDate || new Date().toISOString().split('T')[0]"
                                                            @change="customDateChange"
                                                        >
                                                    </div>
                                                    <div class="date-input-wrapper" style="flex: 1;">
                                                        <input 
                                                            type="date" 
                                                            class="form-control" 
                                                            v-model="filterEndDate"
                                                            placeholder="End Date"
                                                            :min="filterStartDate"
                                                            :max="new Date().toISOString().split('T')[0]"
                                                            @change="customDateChange"
                                                        >
                                                    </div>
                                                </div>
                                                <!-- <div class="or-divider">
                                                    <span class="or-text">OR</span>
                                                </div>
                                                <div class="yearMonthBox d-flex gap-4 mt-3">
                                                    <div class="select-wrapper" style="flex: 1;">
                                                        <select 
                                                            class="form-control" 
                                                            v-model="selectedYear"
                                                            @change="onYearMonthChange"
                                                        >
                                                            <option value="">Select Year</option>
                                                            <option v-for="year in years" :value="year">{{ year }}</option>
                                                        </select>
                                                    </div>
                                                    <div class="select-wrapper" style="flex: 1;">
                                                        <select 
                                                            class="form-control" 
                                                            v-model="selectedMonth"
                                                            @change="onYearMonthChange"
                                                        >
                                                            <option value="">Select Month</option>
                                                            <option v-for="month in months" :value="month.value">{{ month.month }}</option>
                                                        </select>
                                                    </div>
                                                </div> -->
                                            </div>
                                        </div>
                                        
                                        <div class="filterBtnHolder">
                                            <button 
                                                type="button"
                                                class="btn btn-primary" 
                                                @click.stop="applyFilter"
                                                :disabled="filterStartDate === '' && filterEndDate === ''"
                                                :class="{ 'disabled-btn': filterStartDate === '' && filterEndDate === '' }"
                                            >
                                                Apply Filter
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </b-dropdown>
                            <button 
                                                type="button"
                                                class="btn filter-btn-dropdown exportBtn ml-2" 
                                                @click.stop="resetFilter"
                                                :disabled="filterStartDate === '' && filterEndDate === ''"
                                                :class="{ 'disabled-btn': filterStartDate === '' && filterEndDate === '' }"
                                            >
                                                Reset
                                            </button>
                        </div>
                        
                    </div>
                    <div class="row px-3 justify-content-center mt-3 mb-0 pb-0">
                        <div class="col-12 text-center d-flex justify-content-center gap-4 remove-row-gap align-items-center flex-wrap mb-0 pb-0">
                            <button class="exportBtn" @click="onExportTypeChange()">Export credit smart data</button>
                            <template v-if="!showCreditSmartUpload">
                                <button class="exportBtn" @click="showCreditSmartUpload = true">Upload credit smart data</button>
                            </template>
                            <template v-else>
                                <div class="d-flex gap-3 align-items-center credit-smart-upload-section flex-wrap">
                                    <div class="file-input-wrapper mr-2">
                                        <input
                                            type="file"
                                            class="form-control file-text-input"
                                            id="creditSmartUploadFile"
                                            accept=".xlsx"
                                            @change="onCreditSmartFileSelected"
                                        >
                                    </div>
                                    <button class="exportBtn" @click="uploadCreditSmartData()" :disabled="!selectedFile">Upload</button>
                                    <button class="exportBtn cancelBtn" @click="cancelCreditSmartUpload()">Cancel</button>
                                </div>
                                <span v-if="uploadErrorMessage" class="upload-error-text">{{ uploadErrorMessage }}</span>
                            </template>
                        </div>
                    </div>
                    <div class="row tableContainer pb-4 px-3 ml-0 mt-5 ">
                      <div class="col-12">
                        <table class="table table-responsive mt-2 customerTable">
                          <thead class="tableHeading">
                            <tr>
                              <!-- <th style="width:5%">S.No.</th> -->
                              <th style="width:20%">Dealer Name</th>
                              <th style="width:25%">First Name</th>
                              <th style="width:15%">Last Name</th>
                              <th style="width:20%">Lender Agent</th>
                              <th style="width:20%">Requested Amount</th>
                              <th style="width:20%">Term Requested</th>
                              <th style="width:20%">Status</th>
                              <th style="width:20%">Credit Analyst</th>
                              <th style="width:15%">Make</th>
                              <th style="width:15%">Model</th>
                              <th style="width:15%">Year</th>
                              <th style="width:15%">Mileage</th>
                              <th style="width:15%">Submitted Date</th>
                            </tr>
                          </thead>
                          <template>
                          <tbody v-if="creditSmartListData.length>0">
                            <template v-for="(creditSmart, index) in creditSmartListData" >
                              <tr>
                                <!-- <td class="tableMobile align-middle">{{ (currentPage - 1) * perPage + index + 1 }}</td> -->
                                <td class="tableName align-middle">{{creditSmart.dealerName}}</td>
                                <td class="tableEmail align-middle">{{creditSmart.firstName}}</td>
                                <td class="tableMobile align-middle">{{creditSmart.lastName}}</td>
                                <td class="tableMobile align-middle">{{creditSmart.lenderAgent}}</td>
                                <td class="tableMobile align-middle">{{formatNumberInternational(creditSmart.requestedAmt)}}</td>
                                <td class="tableMobile align-middle">{{creditSmart.termRequested}}</td>
                                <td class="tableMobile align-middle">{{creditSmart.status}}</td>
                                <td class="tableMobile align-middle">{{creditSmart.underWriter}}</td>
                                <td class="tableMobile align-middle">{{creditSmart.vehicleMake}}</td>
                                <td class="tableMobile align-middle">{{creditSmart.vehicleModel}}</td>
                                <td class="tableMobile align-middle">{{creditSmart.vehicleYear}}</td>
                                <td class="tableMobile align-middle">{{creditSmart.vehicleMileage}}</td>
                                <td class="tableMobile align-middle">{{creditSmart.submitDate}}</td>
                              </tr>
                            </template>
                          </tbody>
                          <tbody v-else class="text-center">
                            <tr><td colspan="12">{{noResult}}</td></tr>
                          </tbody>
                          </template>
                        </table>
                      </div>
                    </div>
                </div>
                <div class="mt-5 mb-5 pb-3">
                        <b-pagination align="center" v-if="rows>perPage && creditSmartListData.length>0"
                         v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        first-number
                        last-number
                        @input="pagination"
                        class="customPagination"
                        ></b-pagination>
                </div>
        <!--successful merge dialog code start-->
         <div v-if="isExportSuccess" class="modal" id="exportSuccessModal" @click.self="closeExportSuccess()">
          <div class="modal-content">
            <div class="modal-body">
              <img src="../assets/checkicon-min.png" alt="" class="logo" v-if="exportSuccess" />
              <img src="../assets/error.png" alt="" class="logo" v-else />
              <p class="modalText">
              {{exportSuccess || exportError}}
              </p>
            </div>
          </div>
        </div>
        <!--successful merge dialog code end-->
                <bottom-footer></bottom-footer>
            </div>
        </div>
    </div>
    </template>
    <script>
    import TopHeader from "@/components/TopHeader.vue";
    import MainMenu from "@/components/Menu.vue";
    import BottomFooter from "@/components/BottomFooter.vue";
    import httpcommon from "../js/http-common.js";
    import moment from 'moment';
    
    export default {
      components: {
        MainMenu,
        TopHeader,
        BottomFooter,
      },
      name: "creditSmart",
    
      data() {
      return {
        creditSmartListData: [],
        noResult: '',
        isLoading: false,
        rows: 0,
        currentPage: 1,
        perPage: 10,
        activitySearch: '',
        creditSmartListSearch: '',
        isCreditSmartListSearch: false,
        isSearch: false,
        exportType: '',
        dataDateRange: '',  
        isExportSuccess: false,
        exportSuccess: '',
        exportError: '',
        months: [{month: 'January',value:1}, {month: 'February',value:2}, {month: 'March',value:3}, {month: 'April',value:4}, {month: 'May',value:5}, {month: 'June',value:6}, {month: 'July',value:7}, {month: 'August',value:8}, {month: 'September',value:9}, {month: 'October',value:10}, {month: 'November',value:11}, {month: 'December',value:12}],
        years: [],
        filterStartDate: '',
        filterEndDate: '',
        showCreditSmartUpload: false,
        selectedFile: null,
        uploadErrorMessage: '',
      }
      },
      methods: {
        getCreditSmartList () {
            this.isLoading = true
            this.noResult = ''
            this.creditSmartListData = []
            let searchParams = new URLSearchParams()
            // Use filter values if available, otherwise use original values
            if(this.filterStartDate) {
                searchParams.append('startDate',this.filterStartDate)
            } 
            if(this.filterEndDate) {
                searchParams.append('endDate',this.filterEndDate)
            }
            if(this.creditSmartListSearch) {
                searchParams.append('search',this.creditSmartListSearch)
            }
             httpcommon.get(`/credit-smart/fetch?${searchParams.toString()}&page=${this.currentPage-1}&size=${this.perPage}`).then(response=>{
                this.isLoading = false
                if(response && response.data) {
                    this.creditSmartListData = response.data.content || []
                    this.rows = response.data.totalElements || 0
                    if (this.creditSmartListData.length === 0) {
                      this.noResult = response.data.message || 'No records found'
                    }
                } else {
                    this.creditSmartListData = []
                    this.noResult = 'No records found'
                }
            }).catch(error=>{
                this.isLoading = false
                this.creditSmartListData = []
                this.noResult = 'Unable to load credit smart data'
                console.log(error)
            })
        },
        pagination () {
          this.getCreditSmartList()
        },
        
        clearCreditSmartSearch() {
          this.creditSmartListSearch = '';
          if(this.isCreditSmartListSearch) {
            this.isCreditSmartListSearch = false
            this.currentPage = 1
            this.perPage = 10
            this.getCreditSmartList()
          }
        },
        searchCreditSmart() {
          if(this.creditSmartListSearch) {
            this.isCreditSmartListSearch = true
            this.currentPage = 1
            this.perPage = 10
            this.getCreditSmartList()
          } else {
            this.isCreditSmartListSearch = false
          }
        },
       
        isActiveRoute(route) {
          return this.$route.path === route;
        },
        retrieveData: function () {
          httpcommon
            .get("/userrole/")
            .then((response) => {
              this.userroles = response.data;
            })
            .catch((e) => {
              console.log(e);
              this.errorslist.push(e);
            });
          httpcommon
            .get("/staticdata/status/")
            .then((response) => {
              this.status = response.data;
            })
            .catch((e) => {
              this.errorslist.push(e);
            });
        },
        myFunction() {
          var elmnt = document.getElementById("height2");
          var elmnt1 = document.getElementById("height3");
          if (!elmnt || !elmnt1) {
            return
          }
          var txt = elmnt.offsetHeight;
          var txt1 = elmnt1.offsetHeight;
          $("#employee").css("margin-top", txt + txt1 + 3);
        },
        menuheight () {
          var elmnt = document.getElementById("height2");
          if (!elmnt) {
            return
          }
          var txt = elmnt.offsetHeight;
          $('#height3').css('margin-top', txt)
        },
        
        onExportTypeChange() {
        this.DownloadCreditSmartCSV();
        },
        DownloadCreditSmartCSV() {
          this.isLoading = true
          let params = new URLSearchParams()
          params.append('startDate',this.filterStartDate)
          params.append('endDate',this.filterEndDate)

          // Try to get CSV as blob first
          const responseType = 'blob'
          httpcommon.get(`/credit-smart/download?${params.toString()}`, {
            responseType: 'blob'
          }).then( async response=>{
            this.isLoading = false
            const contentType = response.headers['content-type'] || response.headers['Content-Type'] || ''
            if (responseType === 'blob' && contentType.includes('application/json')) {
              try {
                const text = await response.data.text()
                const jsonData = JSON.parse(text)
                if (jsonData.message) {
                  console.log(jsonData.message, 'response.data.message1')
                  // You might want to show an error message to the user here
                  this.isExportSuccess = true
                  this.exportError = jsonData.message
                  setTimeout(()=>{
                    this.isExportSuccess = false
                    this.exportError = ''
                  },2000)
                }
              } catch (parseError) {
                console.error('Error parsing JSON from blob:', parseError)
              }
            } else if (responseType === 'blob') {
            if (response.data instanceof Blob) {
                this.isExportSuccess = true
                this.exportSuccess = 'Credit Smart Data exported successfully'
                setTimeout(()=>{
                  this.isExportSuccess = false
                  this.exportSuccess = ''
                },2000)
              this.downloadBlobAsCSV(response.data, 'Credit_Smart' );
            } 
          } else {
            // Handle JSON response
            if (response.data && response.data.message) {
              console.log(response.data.message, 'response.data.message2')
              // You might want to show an error message to the user here
            }
          }
          })
          .catch(error=>{
            console.log(error,'error')
            this.isLoading = false
          });
        },
       
        downloadBlobAsCSV(blob, fileNametxt) {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          const fileName = fileNametxt + '_' + moment(new Date()).format('MM-DD-YYYY') + '.csv';
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          window.URL.revokeObjectURL(url);
        },
        closeFilterMenu() {
          // Close the filter dropdown
          if (this.$refs.filterDropdown) {
            this.$refs.filterDropdown.hide();
          }
        },
        resetFilter() {
          // Reset all filter values
          this.filterStartDate = '';
          this.filterEndDate = '';
          this.currentPage = 1;
          this.perPage = 10;
          this.getCreditSmartList();
          // Close the dropdown
          this.closeFilterMenu();
        },
        applyFilter() {
          // Apply filters and refresh data
          this.currentPage = 1;
          this.size = 10;
          this.getCreditSmartList();
          // Close the dropdown
          this.closeFilterMenu();
        },
        customDateChange() {
          this.selectedYear = ''
          this.selectedMonth = ''
        },
        onYearMonthChange() {
          this.filterStartDate = ''
          this.filterEndDate = ''
        },
        formateRequestedDate(date) {
           return new Date(date).toLocaleDateString('en-US', { year: 'numeric', month: 'long' })
        },
        
        formatNumberInternational (number) {
        if (number === null || number === undefined || number === '') {
          return '$0.00'
        }
        return '$' + parseFloat(number).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },
        onCreditSmartFileSelected (event) {
          const file = event.target.files[0]
          const validMimeTypes = [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          ]
          if (file && (validMimeTypes.includes(file.type) || file.name.toLowerCase().endsWith('.xlsx'))) {
            this.selectedFile = file
            this.uploadErrorMessage = ''
          } else {
            this.uploadErrorMessage = 'Please upload a valid .xlsx file.'
            this.selectedFile = null
            event.target.value = ''
          }
        },
        uploadCreditSmartData () {
          if (!this.selectedFile) {
            this.uploadErrorMessage = 'Please select an .xlsx file.'
            return
          }
          this.isLoading = true
          this.uploadErrorMessage = ''
          const fd = new FormData()
          fd.append('file', this.selectedFile, this.selectedFile.name)
          httpcommon.post('/credit-smart/upload', fd, {
            headers: { 'Content-Type': 'multipart/form-data' }
          }).then(response => {
            this.cancelCreditSmartUpload()
            this.currentPage = 1
            this.filterStartDate = ''
            this.filterEndDate = ''
            this.creditSmartListSearch = ''
            this.isCreditSmartListSearch = false
            this.isExportSuccess = true
            this.exportSuccess = (response.data && response.data.message) || 'Credit smart data uploaded successfully'
            setTimeout(() => {
              this.isExportSuccess = false
              this.exportSuccess = ''
            }, 2000)
            this.getCreditSmartList()
          }).catch(error => {
            this.isLoading = false
            const errorMessage = (error.response && error.response.data && error.response.data.message) || 'Failed to upload file. Please try again.'
            this.isExportSuccess = true
            this.exportError = errorMessage
            setTimeout(() => {
              this.isExportSuccess = false
              this.exportError = ''
            }, 2000)
            const fileInput = document.getElementById('creditSmartUploadFile')
            if (fileInput) fileInput.value = ''
            this.selectedFile = null
          })
        },
        cancelCreditSmartUpload () {
          this.showCreditSmartUpload = false
          this.selectedFile = null
          this.uploadErrorMessage = ''
          const fileInput = document.getElementById('creditSmartUploadFile')
          if (fileInput) fileInput.value = ''
        },
        closeExportSuccess () {
          this.isExportSuccess = false
          this.exportSuccess = ''
          this.exportError = ''
        },
        
      },
      beforeDestroy () {
        window.removeEventListener('resize', this.myFunction)
        window.removeEventListener('resize', this.menuheight)
      },
      created () {
        window.addEventListener('resize', this.myFunction)
        window.addEventListener('resize', this.menuheight)
      },
      mounted () {
        this.myFunction()
        this.menuheight()
        this.getCreditSmartList()
      },
    }
</script>
<style scoped>
    .customerTable {
      font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
      /* line-height: 32px; */
      table-layout: auto;
      width: 100%;
    }
    .customerTable thead tr {
      color: #000000;
      background: #E1E4E7;
      font: 600 12px 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
      /* line-height: 32px; */
    }
    .customerTable thead tr th {
        border-top: none;
        white-space: nowrap;
    }
    .customerTable tbody tr td {
      font-size: 14px;
      font-weight: 600;
      color: #2C2C2C;
      white-space: nowrap;
    }
    tbody tr {
      border-bottom: 1px solid #dbdbdb;
    }
    .mergeStatus {
        color: #00AA00 !important;
    }
    .unMergeStatus {
        color: #F22A0E !important;
    }
    .loader-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(255, 255, 255, 0.8);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 9999;
    }
    .loader {
      border: 12px solid #f3f3f3;
      border-top: 12px solid #3498db;
      border-radius: 50%;
      width: 60px;
      height: 60px;
      animation: spin 2s linear infinite;
    }
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
    .customPagination ::v-deep .page-link {
      display: flex;
      align-items: center;
      justify-content: center;
      border: none ;
      height: 30px;
      width: 30px;
      margin: 0;
      padding: 10px;
      font-size: 20px;
      color: #9B9B9B;
      margin-left: 10px;
    }
    .customPagination ::v-deep .active .page-link {
      background-color: #005DF1;
      border-radius: 8px;
      color: #FFFFFF;
      margin-left: 10px;
    }
    .pagination.customPagination ::v-deep .page-item:first-child .page-link,
    .pagination.customPagination ::v-deep .page-item:last-child .page-link {
      font-size: 40px !important; /* Adjust the font size as needed */
      padding: 0 20px 10px 20px;
    }
    .navLinks {
        list-style: none;
        display: flex;
        padding-left: 0;
        justify-content: center;
    }
    .navLinks li {
        padding: 10px 35px 10px 0px;
    }
    .linkItem {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-size: 18px;
    font-weight: 600;
    color: #8C8C8C;
    Padding:10px 30px 10px 30px;
    border-radius: 8px;
    }
    .linkItem:hover {
        color: #FFFFFF;
        background-color: #1E90FF;
    }
    .navLinks .active {
    color: #FFFFFF !important;
    background-color: #1E90FF;
    }
    .activitySearch input, .activitySearch select {
      font: 400;
      font-size: 16px;
      color: #1C1B1F;
      border: 1px solid #E4ECF4;
      border-radius: 8px;
      padding: 10px;
      height: 44px !important;
      width: 100%;
    }

    .search-input-wrapper {
      position: relative;
      width: 100%;
    }

    .search-input {
      padding-right: 40px !important;
    }

    .clear-search-btn {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      background: none;
      border: none;
      cursor: pointer;
      padding: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #666;
      transition: color 0.2s;
      z-index: 10;
    }

    .clear-search-btn:hover {
      color: #000;
    }

    .clear-search-btn svg {
      width: 16px;
      height: 16px;
    }
    .activityBtn button {
      border-radius: 8px;
      color: #FFFFFF;
      font-weight: 600;
      font-size: 18px;
      background-color: #1E90FF;
      padding: 10px;
      height: 44px;
      width: 160px;
      border: none;
      width: 100%;
    }
    /* MMR Export Drawer Styles */
    .mmrExportDrawerWrapper {
      position: relative;
    }

    .drawer-backdrop {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 1040;
      transition: opacity 0.3s ease;
    }

    .mmrExportDrawer {
      position: fixed;
      top: 0;
      right: 0;
      width: 100%;
      max-width: 500px;
      height: 100%;
      background-color: #ffffff;
      box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
      z-index: 1041;
      transform: translateX(100%);
      transition: transform 0.3s ease;
      overflow-y: auto;
      display: flex;
      flex-direction: column;
    }

    .mmrExportDrawer.drawer-open {
      transform: translateX(0);
    }

    .drawer-header {
      padding: 20px;
      border-bottom: 1px solid #e0e0e0;
      background-color: #ffffff;
      position: sticky;
      top: 0;
      z-index: 10;
    }

    .drawer-header h2 {
      margin: 0;
      font-size: 24px;
      font-weight: 600;
      color: #000000;
    }

    .drawer-header button {
      font-size: 24px;
      color: #666;
      background: none;
      border: none;
      cursor: pointer;
      padding: 0;
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: color 0.2s;
    }

    .drawer-header button:hover {
      color: #000;
    }

    .vehicleInfo {
      padding: 20px;
      border-bottom: 1px solid #e0e0e0;
    }

    .headerData {
      margin-bottom: 20px;
    }

    .leftData h3 {
      margin: 0 0 10px 0;
      font-size: 20px;
      font-weight: 600;
      color: #000000;
    }

    .metaInfoFlexItem {
      margin-top: 10px;
    }

    .metaInfoFlexItem p {
      margin: 0;
      font-size: 14px;
      color: #666;
    }

    .metaInfoFlexItem p strong {
      color: #000;
      font-weight: 600;
    }

    .rightData {
      display: flex;
      align-items: center;
    }

    /* .exportBtn {
      background: none;
      border: none;
      cursor: pointer;
      padding: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background-color 0.2s;
      border-radius: 4px;
    }

    .exportBtn:hover {
      background-color: #f5f5f5;
    } */
     .exportBtn {
        background-color: #1E90FF;
        color: #ffffff;
        border: none;
        border-radius: 8px;
        padding: 10px;
        height: 44px;
        margin-right: 10px;
        /* width: 100%; */
     }
     .exportBtn.cancelBtn {
        background-color: #6c757d;
     }
     .exportBtn.cancelBtn:hover {
        background-color: #5a6268;
     }
     .credit-smart-upload-section {
        flex-wrap: wrap;
     }
     .credit-smart-upload-section .file-input-wrapper {
        min-width: 220px;
     }
     .credit-smart-upload-section input[type="file"] {
        padding: 8px;
        border: 1px solid #E4ECF4;
        border-radius: 8px;
        font-size: 14px;
        height: 44px;
        width: 100%;
     }
     .upload-error-text {
        display: block;
        width: 100%;
        margin-top: 8px;
        color: #F22A0E;
        font-size: 14px;
        margin-top: 0;
     }

    .exportCalendar {
      margin-top: 20px;
    }

    .commonFomrWrapper {
      width: 100%;
    }

    .form-group {
      margin-bottom: 20px;
    }

    .form-label {
      display: block;
      margin-bottom: 8px;
      font-size: 14px;
      font-weight: 500;
      color: #333;
    }

    .form-control {
      padding: 10px;
      border: 1px solid #e0e0e0;
      border-radius: 4px;
      font-size: 14px;
      width: 100%;
    }

    .dateRangeBox {
      width: 100%;
    }

    .date-input-wrapper {
      display: flex;
      flex-direction: column;
    }

    .or-divider {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 15px 0;
      position: relative;
    }

    .or-divider::before,
    .or-divider::after {
      content: '';
      flex: 1;
      height: 1px;
      background-color: #e0e0e0;
    }

    .or-text {
      padding: 0 15px;
      color: #666;
      font-size: 14px;
      font-weight: 500;
      background-color: #ffffff;
    }

    .yearMonthBox {
      width: 100%;
    }

    .select-wrapper {
      display: flex;
      flex-direction: column;
    }

    .selectBox {
      width: 100%;
    }

    input[type="date"] {
      width: 100%;
      padding: 10px;
      border: 1px solid #e0e0e0;
      border-radius: 4px;
      font-size: 14px;
      color: #333;
    }

    input[type="date"]:focus {
      outline: none;
      border-color: #005DF1;
      box-shadow: 0 0 0 0.2rem rgba(0, 93, 241, 0.25);
    }

    .drawer-content {
      flex: 1;
      padding: 20px;
      overflow-y: auto;
    }

    .timeline {
      width: 100%;
    }

    .timelineItems {
      position: relative;
      padding-left: 30px;
    }

    .timelineItem {
      position: relative;
      padding-bottom: 30px;
      padding-left: 30px;
    }

    .timelineItem:last-child {
      padding-bottom: 0;
    }

    .timelineMarker {
      position: absolute;
      left: -8px;
      top: 0;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background-color: #005DF1;
      border: 3px solid #ffffff;
      box-shadow: 0 0 0 2px #005DF1;
    }

    .timelineItem::before {
      content: '';
      position: absolute;
      left: -2px;
      top: 16px;
      bottom: -10px;
      width: 2px;
      background-color: #e0e0e0;
    }

    .timelineItem:last-child::before {
      display: none;
    }

    .timelineContent {
      background-color: #f9f9f9;
      padding: 15px;
      border-radius: 8px;
      border-left: 3px solid #005DF1;
    }

    .timelineHeader {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 10px;
    }

    .timelineDate {
      font-size: 14px;
      font-weight: 600;
      color: #333;
      line-height: 1.2;
    }

    .timelineValueWrapper {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      gap: 4px;
      line-height: 1.2;
    }

    .timelineValueLabel {
      font-size: 12px;
      font-weight: 500;
      color: #666;
      /* text-transform: uppercase; */
      letter-spacing: 0.5px;
    }

    .timelineValue {
      font-size: 16px;
      font-weight: 700;
      color: #005DF1;
    }

    .timelineDescription {
      margin: 0;
      font-size: 14px;
      color: #666;
      line-height: 1.5;
    }

    .gap-4 {
      gap: 1rem;
    }

    @media (max-width: 768px) {
      .mmrExportDrawer {
        max-width: 100%;
      }
    }

    /* Filter Button & Dropdown Styles */
    .tableFilterAction {
      display: flex;
      align-items: center;
    }

    .filter-btn-dropdown {
      width: 100%;
      height: 44px;
    }

    .filter-btn-dropdown ::v-deep .btn {
      width: 100%;
      height: 44px;
      border: 1px solid #E4ECF4;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;
      background-color: #1E90FF;
      color: #ffffff;
      font-weight: 400;
      transition: all 0.2s;
    }

    .filter-btn-dropdown ::v-deep .btn::after {
          display: none;
    }

    .filter-btn-dropdown ::v-deep .btn:hover,
    .filter-btn-dropdown ::v-deep .btn:focus,
    .filter-btn-dropdown ::v-deep .btn:not(:disabled):not(.disabled):active {
      /* background-color: #f5f5f5; */
      /* border-color: #E4ECF4; */
      /* color: #1C1B1F; */
      box-shadow: none;
    }

    .filter-btn-dropdown ::v-deep .dropdown-menu {
      min-width: 400px;
      max-width: 500px;
      padding: 0;
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      margin-top: 8px;
    }

    .comm-dropdown.filterMenuOuter {
      padding: 0;
    }

    .form-wrap {
      padding: 20px;
    }

    .filter-header {
      margin-bottom: 20px;
      padding-bottom: 15px;
      border-bottom: 1px solid #e0e0e0;
    }

    .filter-header h3 {
      margin: 0;
      font-size: 18px;
      font-weight: 600;
      color: #000000;
    }

    .close-btn {
      /* width: 32px;
      height: 32px; */
      display: flex;
      align-items: center;
      justify-content: center;
      color: #666;
      border: none;
      background: none;
      cursor: pointer;
      padding: 0;
      transition: color 0.2s;
    }

    .close-btn:hover {
      color: #000;
      background-color: #f5f5f5;
      border-radius: 4px;
    }

    .close-btn svg {
      width: 20px;
      height: 20px;
    }

    .form-row {
      margin-bottom: 20px;
    }

    .inputBox {
      width: 100%;
    }

    .selectBox {
      width: 100%;
    }

    .form-label {
      display: block;
      margin-bottom: 8px;
      font-size: 14px;
      font-weight: 500;
      color: #333;
    }

    .primary-radio {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    .primary-radio .form-check {
      display: flex;
      align-items: center;
      margin: 0;
    }

    .primary-radio .form-check-input {
      margin-top: 0;
      margin-right: 8px;
      width: 18px;
      height: 18px;
      cursor: pointer;
    }

    .primary-radio .form-check-label {
      font-size: 14px;
      color: #333;
      cursor: pointer;
      margin: 0;
    }

    .primary-radio .form-check-input:checked {
      background-color: #1E90FF;
      /* border-color: #005DF1; */
      border-color: #1E90FF;
    }

    .primary-radio .form-check-input:focus {
      box-shadow: 0 0 0 0.2rem rgba(0, 93, 241, 0.25);
      border-color: #005DF1;
    }

    .filterBtnHolder {
      display: flex;
      justify-content: flex-end;
      gap: 12px;
      margin-top: 20px;
      padding-top: 20px;
      border-top: 1px solid #e0e0e0;
    }

    .filterBtnHolder .btn {
      min-width: 100px;
      padding: 10px 20px;
      font-size: 14px;
      font-weight: 500;
      border-radius: 4px;
    }

    .filterBtnHolder .btn-outline-primary {
      border-color: #1E90FF;
      color: #1E90FF;
      background-color: #ffffff;
    }

    .filterBtnHolder .btn-outline-primary:hover {
      /* background-color: #005DF1; */
      background-color: #1E90FF;
      color: #ffffff;
    }

    .filterBtnHolder .btn-primary {
      background-color: #1E90FF;
      border-color: #1E90FF;
      color: #ffffff;
    }

    .filterBtnHolder .btn-primary:hover {
      background-color: #1E90FF;
      border-color: #0047c4;
    }

    .mb-20 {
      margin-bottom: 20px;
    }

    .flex-grow-1 {
      flex-grow: 1;
    }
    .disabled-btn {
      cursor: default;
    }
    .data-availability-text {
      font-size: 13px;
      color: #1E90FF;
      font-weight: 600;
    }
    .total-records-text {
      font-size: 14px;
      color: #2C2C2C;
      font-weight: 400;
    }
    .expand-arrow {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      transition: transform 0.3s ease;
      color: #1E90FF;
    }
    .expand-arrow.expanded {
      transform: rotate(90deg);
    }
    .expanded-row {
      background-color: #f9f9f9;
    }
    .expanded-content {
      padding: 20px !important;
      background-color: #f9f9f9;
    }
    .expanded-content-wrapper {
      display: flex;
      flex-direction: column;
      gap: 20px;
    }
    .expanded-table-container {
      width: fit-content;
      overflow-x: auto;
    }
    .expanded-table {
      width: 100%;
      background-color: #ffffff;
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      overflow: hidden;
    }
    .expanded-table thead {
      background-color: #E1E4E7;
    }
    .expanded-table thead th {
      padding: 12px;
      font-weight: 600;
      font-size: 12px;
      color: #000000;
      border-bottom: 1px solid #dbdbdb;
    }
    .expanded-table tbody td {
      padding: 12px;
      font-size: 14px;
      color: #2C2C2C;
      border-bottom: 1px solid #dbdbdb;
    }
    .expanded-table tbody tr:last-child td {
      border-bottom: none;
    }
    .expanded-controls {
      display: flex;
      /* justify-content: space-between; */
      align-items: center;
      gap: 20px;
      flex-wrap: wrap;
    }
    .radio-buttons-group {
      display: flex;
      gap: 20px;
      flex-wrap: wrap;
    }
    .radio-buttons-group .form-check {
      display: flex;
      align-items: center;
      margin: 0;
    }
    .radio-buttons-group .form-check-input {
      margin-top: 0;
      margin-right: 8px;
      width: 18px;
      height: 18px;
      cursor: pointer;
    }
    .radio-buttons-group .form-check-label {
      font-size: 14px;
      color: #333;
      cursor: pointer;
      margin: 0;
    }
    .radio-buttons-group .form-check-input:checked {
      background-color: #1E90FF;
      border-color: #1E90FF;
    }
    .expanded-action-btn {
      background-color: #1E90FF;
      color: #ffffff;
      border: none;
      border-radius: 8px;
      padding: 10px 20px;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      transition: background-color 0.2s;
    }
    .expanded-action-btn:hover {
      background-color: #005DF1;
    }
    .modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 2;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.modal-heading {
  font-size: 14px;
}
.modal-heading::after {
  content:' ';
  height: 1px;
  background: #9B9B9B;
  width: 100%;
  display: block
}
.modal-content {
  border: #ffffff;
  background-color: #ffffff;
  padding: 36px 40px 36px 40px !important;
  width: 70vh !important;
  height: auto !important;
  max-height: 70vh;
  border-radius: 16px;
  text-align: center;
}
.modalText {
  font-size: 18px;
  font-weight: 400;
  line-height: 26.6px;
  color: #000000;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.modal-body img {
  height:70px
}
.mergeButton, .yesButton {
  background-color: #1E90FF;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  line-height: 21.28px;
  padding: 10px 20px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
}
.yesButton {
  background-color: #6c757d;
}
.yesButton:hover {
  background-color: #5a6268;
}
.mergeButton:hover {
  background-color: #005DF1;
}

.remove-row-gap {
  row-gap: 0;
}
.file-text-input {
  padding: 11px !important;
}

    @media (max-width: 768px) {
      .filter-btn-dropdown ::v-deep .dropdown-menu {
        min-width: 300px;
        max-width: 90vw;
      }
    }
</style>
